import axios from 'axios'
const urlBase = process.env.REACT_APP_URL_BACKEND_BASE

const getCreatePreferenceId = async (cart, payment) => {
  if (urlBase && process.env.REACT_APP_CREATE_PREFERENCE_ID) {
    const url = `${urlBase}${process.env.REACT_APP_CREATE_PREFERENCE_ID}`

    const response = await axios.post(url, {
      productos: cart,
      comprador: payment
    })

    return response.data
  }
}

const makeOrder = async (cart, paymentClient, state) => {
  if (urlBase && process.env.REACT_APP_MAKE_ORDER) {
    const url = `${urlBase}${process.env.REACT_APP_MAKE_ORDER}${state}`

    const response = await axios.post(url, {
      productos: cart,
      comprador: paymentClient
    })

    return response.data
  }
}

// Cobra con tarjeta y registra la venta en una sola llamada.
// El monto NO viaja en el payload: lo calcula el backend con los precios de la
// base a partir del carrito, así el importe cobrado no depende del cliente.
const processPayment = async ({
  token,
  cart,
  buyer,
  paymentMethodId,
  installments,
  issuerId,
  identificationType,
  identificationNumber
}) => {
  if (urlBase && process.env.REACT_APP_PROCESS_PAYMENT) {
    const url = `${urlBase}${process.env.REACT_APP_PROCESS_PAYMENT}`

    const response = await axios.post(url, {
      token,
      productos: cart,
      comprador: buyer,
      payment_method_id: paymentMethodId,
      installments,
      issuer_id: issuerId,
      payer: {
        identification: {
          type: identificationType,
          dni: identificationNumber
        }
      }
    })

    return response.data
  }
}

const getDataTransfer = async () => {
  if (urlBase && process.env.REACT_APP_DATA_TRANSFER) {
    const url = `${urlBase}${process.env.REACT_APP_DATA_TRANSFER}`

    const response = await axios.get(url)

    return response.data
  }
}

export const paymentService = {
  makeOrder,
  processPayment,
  getCreatePreferenceId,
  getDataTransfer
}
